/**
 * Client-side price calculation for display (authoritative totals are computed on the server at checkout).
 */
export function getGamePriceDetails(game, platform, discounts) {
  if (!game) return { price: 0, originalPrice: 0, discount: 0 };

  const plat = platform || 'windows';
  const originalPrice =
    game.platforms?.[plat]?.originalPrice !== undefined
      ? game.platforms[plat].originalPrice
      : game.platforms?.[plat]?.price !== undefined
        ? game.platforms[plat].price
        : game.price || 0;

  const now = new Date();
  const activeDiscounts = (discounts || []).filter(
    (d) =>
      d.method === 'automatic' &&
      d.isActive &&
      new Date(d.startDate) <= now &&
      new Date(d.endDate) >= now
  );

  let maxDiscountPercent = game.discount || 0;

  activeDiscounts.forEach((disc) => {
    let applies = false;
    if (disc.appliesTo === 'all') {
      applies = true;
    } else if (disc.appliesTo === 'categories') {
      const gameCatId = game.category?._id || game.category?.id || game.category;
      if (
        gameCatId &&
        disc.selectedCategories?.some(
          (catId) => catId.toString() === gameCatId.toString()
        )
      ) {
        applies = true;
      }
    } else if (disc.appliesTo === 'games') {
      const gameId = game._id || game.id;
      if (
        gameId &&
        disc.selectedGames?.some((gId) => gId.toString() === gameId.toString())
      ) {
        applies = true;
      }
    }

    if (applies && disc.discount > maxDiscountPercent) {
      maxDiscountPercent = disc.discount;
    }
  });

  const price =
    maxDiscountPercent > 0
      ? Number((originalPrice * (1 - maxDiscountPercent / 100)).toFixed(2))
      : originalPrice;

  return {
    price,
    originalPrice,
    discount: maxDiscountPercent,
  };
}
